import React from 'react';
import { createRoot } from 'react-dom/client';
import ScrollToTopButton from './components/ScrollToTopButton';

let root = null;
let mountedEl = null;

const mount = () => {
  const el = document.getElementById('scroll-top-root');
  if (!el) return;
  if (!root || mountedEl !== el) {
    root = createRoot(el);
    mountedEl = el;
  }
  root.render(React.createElement(ScrollToTopButton));
};

document.addEventListener('turbo:load', mount);
window.scrollTopMount = mount;
